(function ($, Drupal, drupalSettings) {
  'use strict';

  //
  // Make entire area clickable, and send user to event details page on click.
  //
  Drupal.behaviors.ucwsEventFeedGoToEvent = {
    attach: function (context, settings) {
      $('.block.event-feed').on('click','.event-wrapper', function (event) {
        window.location = $(this).data("href");
      });
    }
  };
})(jQuery, Drupal, drupalSettings);
